<template>
  <div class="search-input" :class="{ 'shadow': $route.path === '/token-info' }">
    <img class="search-icon" :src="curSearchIcon" alt="" />
    <div class="input-wrap">
      <input
        type="text"
        ref="myInput"
        :placeholder="placeholder"
        v-model="inputVal"
        @input="inputChange"
        @focus="onFocus"
        @keydown.enter="onEnter"
      />
      <img
        v-if="inputVal"
        class="delete"
        :src="deleteImg"
        @click="onDelete"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String
    },
    searchIcon: {
      type: String
    },
    // 是否需要聚焦
    focus: {
      type: Boolean
    },
  },
  data() {
    return {
      inputVal: '',
      resultList: [],
      searchStatus: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs && this.$refs.myInput && !this.isMobileSize && this.focus) {
        this.$refs.myInput.focus()
      }
    })
  },
  computed: {
    ...mapGetters(['isMobileSize']),
    searchImg() {
      return require(`../../assets/search-token/search${this.darkModeImg}.png`)
    },
    deleteImg() {
      return require(`../../assets/custom-token/close${this.darkModeImg}.png`);
    },
    curSearchIcon() {
      if (this.searchIcon) {
        return this.searchIcon
      } else {
        return this.searchImg
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        this.inputVal = val
      },
      immediate: true
    }
  },
  methods: {
    onFocus() {
      this.$emit('focus');
    },
    onDelete() {
      // console.log('onDelete');
      this.inputVal = '';
      this.$emit('getInputVal', this.inputVal);
    },
    onEnter() {
      // this.$emit('getInputVal', this.params);
      // this.onSearch();
    },
    async onSearch() {
      this.$emit('getInputVal', this.inputVal);
    },
    inputChange() {
      this.$emit('getInputVal', this.inputVal);
      // if (this.inputVal.trim()) {
      // } else {
      //   this.$emit('getInputVal', this.params);
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.search-input {
  display: flex;
  align-items: center;
  gap: 0 8px;
  height: 38px;
  background: var(--bg-57);
  border: 1px solid var(--border-17);
  border-radius: 8px;
  padding: 0 12px;
  &.shadow {
    box-shadow: none;
  }
  .search-icon {
    width: 24px;
    height: 24px;
  }
  .input-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    height: inherit;
    input {
      height: inherit;
      flex: 1;
      padding: 0;
      font-size: 14px;
      border: none;
      outline: none;
      background: none;
      color: var(--color-29);
    }

    input::-webkit-input-placeholder,
    textarea::-webkit-input-placeholder {
      color: var(--input-placeholder-1);
      font-size: 14px;
    }

    input:-moz-placeholder,
    textarea:-moz-placeholder {
      color: var(--input-placeholder-1);
      font-size: 14px;
    }

    input::-moz-placeholder,
    textarea::-moz-placeholder {
      color: var(--input-placeholder-1);
      font-size: 14px;
    }
    input:-ms-input-placeholder,
    textarea:-ms-input-placeholder {
      color: var(--input-placeholder-1);
      font-size: 14px;
    }

    .delete {
      margin-left: 8px;
      width: 14px;
      height: 14px;
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 680px) {
  .search-input {
    height: 38px;
    border-radius: 8px;
    &.shadow {
      box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.08);
    }
    .search-icon {
      width: 20px;
      height: 20px;
    }
    .input-wrap {
      input {
        font-size: 12px;
      }
      input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: var(--input-placeholder-1);
        font-size: 12px;
      }

      input:-moz-placeholder,
      textarea:-moz-placeholder {
        color: var(--input-placeholder-1);
        font-size: 12px;
      }

      input::-moz-placeholder,
      textarea::-moz-placeholder {
        color: var(--input-placeholder-1);
        font-size: 12px;
      }
      input:-ms-input-placeholder,
      textarea:-ms-input-placeholder {
        color: var(--input-placeholder-1);
        font-size: 12px;
      }
      .delete {
        margin-left: 10px;
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
